<template>
	<div class="container">
		<div class="top-img">
			<div class="bg  flex-col items-center">
				<div class="title">{{detail.title}}</div>
				<div class="public-time">
					发布时间&ensp;{{detail.addTime}}
				</div>
			</div>
		</div>
		<div class="content">
			<div class="center" v-html="detail.conment">
			</div>
		</div>
	</div>
</template>

<script>
	import {newsDetailApi} from '../../http/api/ordinary.js' 
	export default{
		data(){
			return{
				detail:{}
			}
		},
		created() {
			this.init(this.$route.query.id)
		},
		methods:{
			init(id){
				newsDetailApi({
					id
				}).then(res => {
					this.detail = res
				})
			}
		}
	}
</script>

<style scoped>
	.container{
		font-size: 18px;
	}
	.top-img {
		height: 150px;
		background: url('../../assets/image/tingdian.png') no-repeat;
		background-size: 100% 100%;
	}

	.title {
		font-size: .30rem;
		font-weight: 500;
		color: #FFFFFF;
		line-height: .42rem;
		margin-top: 20px;
		letter-spacing: .03rem;
	}

	.public-time {
		font-size: .16rem;
		font-weight: 400;
		color: #FFFFFF;
		line-height: .22rem;
		margin-top: 10px;
	}

	.content {
		background-color: #F5F5F5;
		padding: 10px;
		overflow: hidden;
	}

	.center {
		width: 60%;
		margin: 0 auto;
		min-height: 500px;
		padding: 10px;
		background-color: #ffffff;
		
	}

	.center p {
		font-size: .16rem;
		margin: 0;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #464646;
		line-height: .31rem;
	}
</style>
